import axios from 'axios'
import { Message } from 'element-ui'
import Vue from 'vue'
import router from'../router'
import { isUndefined } from 'lodash'
Vue.config.productionTip = false

const service = axios.create({
  baseURL: '',
  timeout: 60000,
})
// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data;
        // 二进制数据则直接返回
  if(error.response.request.responseType ===  'blob' ){
     Message({
      message:  '文件下载失败。',
      type: 'error',  
    })
    return Promise.reject('文件下载失败。')
  }
    if (data.status === 40001 ) {
      Message({
      message:'身份认证失效，请重新登录！',
      type: 'error',  
    })
   
      // 从 sessionStorage 获取 token
      const token = sessionStorage.getItem('token')
      if(token){  
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("assistant");
        sessionStorage.removeItem("store");
        sessionStorage.removeItem("owner");
       }
      // 企业登录进来的时候做的判断
      getWeb();
      // 没有访问权限 || 没有操作权限
    }else if(data.status === 2003 || data.status === 2004 ) {
      Message({
        message: data.message,
        type: 'error',  
      })
    }else if(data.status === 200  ) {
      Message({
        message: data.data.message,
        type: 'error',  
      })
    }else if(data.status === 500  ) {
        if(data.message.includes('should be unique')){
          Message({
            message:  '已存在相同资源数据',
            type: 'error',  
          })

        }else{
          Message({
            message: data.message || '服务器异常~',
            type: 'error',  
          })
        }
    }else {
      Message({
        message: data.message ||  error.message,
        duration: 5000,
        type: 'error',  
      })
    }
  }
  return Promise.reject(error)
}
// 请求拦截器
service.interceptors.request.use(config => {

    if (sessionStorage.getItem('token')) {
      config.headers['Authorization'] = sessionStorage.getItem('token')
    }
    return config
  },errorHandler)

// 响应拦截器 
service.interceptors.response.use(response => {
  // 未设置状态码则默认成功状态
  let code = response.data.status || 200;
  // 获取错误信息
  const msg =  response.data.message || '系统未知错误，请反馈给管理员'

      // 二进制数据则直接返回
  if(response.request.responseType ===  'blob' || response.request.responseType ===  'arraybuffer'){
    var content = response.headers['content-disposition'];
    var name = content && content.split(';')[1].split('filename=')[1];
    const filename = decodeURIComponent(name) || '';
    // 获取拼接文件名
    const value = {
        data: response.data,
        filename
    }
    // 针对文件下载单独处理
    if( isUndefined(content) && response.request.responseType ===  'blob' && !isImageResponse(response) ){
      Message({
        message: '会话已过期，请重新登录。',
        type: 'error',  
      })
      code = 40001;
    }else {
      return value;
    }
  }
  if( code == 40001 ){
 
    sessionStorage.removeItem('token')
    getWeb();
   
  }
  else if( code != 200 ){
    Message({
      message: msg,
      type: 'error',  
    })
    return Promise.reject('error')
  }else if( code ==200 ) {

    return response.data;
  }
  else {
    return response.data;
  }
},errorHandler)

// service.interceptors.response.use((response) => {
//   return response.data
// }, errorHandler)

export default service;

function isImageResponse(response) {
  const contentType = response.headers.get('Content-Type');
  return /^image\//.test(contentType);
}

function getWeb(){
  const path = router.currentRoute.path;
  const isWeb = path.indexOf('web');
   // 企业登录进来的时候做的判断
    if(isWeb != -1){
      router.replace({
        path: '/login-member' 
      })
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    }else{
      router.replace({
        path: '/login'
      })
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    }
}